import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../lib/metaPixel';
import { Hero } from '../components/sections/Hero';
import { Problem } from '../components/sections/Problem';
import { WhyDidntWork } from '../components/sections/WhyDidntWork';
import { MethodVISA } from '../components/sections/MethodVISA';
import { WhatYouGet } from '../components/sections/WhatYouGet';
import { ForWhom } from '../components/sections/ForWhom';
import { HowItWorks } from '../components/sections/HowItWorks';
import { Proof } from '../components/sections/Proof';
import { FAQ } from '../components/sections/FAQ';
import { Offer } from '../components/sections/Offer';
import { Footer } from '../components/sections/Footer';
export function MemoriaBlindada() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-cream-50 font-sans text-charcoal-900 selection:bg-gold-200 selection:text-navy-900" data-id="element-227">
      <Hero data-id="element-228" />
      <Problem data-id="element-229" />
      <WhyDidntWork data-id="element-230" />
      <MethodVISA data-id="element-231" />
      <WhatYouGet data-id="element-232" />
      <ForWhom data-id="element-233" />
      <HowItWorks data-id="element-234" />
      <Proof data-id="element-235" />
      <FAQ data-id="element-236" />
      <Offer data-id="element-237" />
      <Footer data-id="element-238" />
    </main>;
}